import React from 'react';
import { Checkbox } from 'antd';
import cx from 'classnames';
import EhrBadge from '../EhrBadge';
import { ehrByName } from '../../constants';
import s from './s.module.less';

export type EhrCheckItem = {
    name: string;
    // 自建/未收录 EHR（isCustom，长期 pending 等内部对接）：琥珀色行样式，
    // 缺省 tag 换成 "Not supported yet"
    pending?: boolean;
    // 行尾自定义内容；缺省渲染绿色 Connected tag（pending 行为琥珀色 Not supported yet）
    extra?: React.ReactNode;
};

type Props = {
    items: EhrCheckItem[];
    // 勾选中的 EHR 名集合（= 计费范围 billingEhrs）
    value: string[];
    // next 为变更后的完整选中集；changed 标记本次点击的 EHR 与勾选方向
    onChange: (next: string[], changed: { name: string; checked: boolean }) => void;
};

// 已连接 EHR 的 checkbox 卡片列表（向导 Step 6 与 settings 的 EHR & billing scope 共用）：
// 列出所有连上的 EHR，勾选 = 纳入计费范围
export default function EhrBillingCheckList({ items, value, onChange }: Props) {
    const toggle = (name: string) => {
        const checked = !value.includes(name);
        const next = checked ? [...value, name] : value.filter((n) => n !== name);
        onChange(next, { name, checked });
    };

    return (
        <div>
            {items.map((item) => {
                const checked = value.includes(item.name);
                return (
                    <div
                        key={item.name}
                        role="checkbox"
                        aria-checked={checked}
                        tabIndex={0}
                        className={cx(s.row, checked && s.rowChecked, item.pending && s.rowPending)}
                        onClick={() => toggle(item.name)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') toggle(item.name);
                        }}
                    >
                        <Checkbox checked={checked} />
                        {/* custom（pending）行的 logo 用琥珀色系，与行样式一致（目录外名字兜底色是蓝色） */}
                        <EhrBadge
                            ehr={item.pending ? { ...ehrByName(item.name), color: '#B45309' } : ehrByName(item.name)}
                        />
                        <span className={s.name}>{item.name}</span>
                        {/* 行尾操作区（Disconnect / Reconnect 等）点击不触发勾选 */}
                        {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
                        <span className={s.extra} onClick={(e) => e.stopPropagation()}>
                            {item.extra !== undefined ? (
                                item.extra
                            ) : (
                                <span className={item.pending ? s.tagPending : s.tagOk}>
                                    {item.pending ? 'Not supported yet' : 'Connected'}
                                </span>
                            )}
                        </span>
                    </div>
                );
            })}
        </div>
    );
}
